import format from 'date-fns/format'
import parseJSON from 'date-fns/parseJSON'

/** @type {import('@mui/x-data-grid').GridColDef[]} */

const DATE_FORMAT = 'dd-MM-yyyy HH:mm'
export const iccidColDefs = [
  {
    field: 'iccid',
    headerName: 'ICCID'
  },
  {
    field: 'uploadedAt',
    headerName: 'Uploaded At',
    type: 'dateTime',
    valueGetter: (params) => parseJSON(params.row.uploadedAt),
    valueFormatter: (params) => format(params.value, DATE_FORMAT)
  }
]

/** @type {import('@mui/x-data-grid').GridColDef[]} */
export const msisdnColDefs = [
  {
    field: 'msisdn',
    headerName: 'MSISDN'
  },
  {
    field: 'uploadedAt',
    headerName: 'Uploaded At',
    type: 'dateTime',
    valueGetter: (params) => parseJSON(params.row.uploadedAt),
    valueFormatter: (params) => format(params.value, DATE_FORMAT)
  }
]

/** @type {import('@mui/x-data-grid').GridColDef[]} */
export const provisionStatusColDefs = [
  {
    field: 'iccid',
    headerName: 'ICCID'
  },
  {
    field: 'msisdn',
    headerName: 'MSISDN'
  },
  {
    field: 'orderNo',
    headerName: 'Order No.'
  },
  {
    field: 'uploadedAt',
    headerName: 'Uploaded At',
    valueGetter: (params) => parseJSON(params.row.uploadedAt),
    valueFormatter: (params) => format(params.value, DATE_FORMAT)
  }
]
